import * as Helpers from '../../helpers';

export const BALANCE = 'BALANCE';
export const ERROR = 'ERROR';
export const LOADING = 'LOADING';
export const SIGNIN = 'SIGNIN';
export const SIGNUP = 'SIGNUP';
export const LOAD = 'LOAD';
export const LOGOUT = 'LOGOUT';

export const signin = (username, password, history) => Helpers.api(
  'signin',
  'POST',
  { password, username },
  () => setTimeout(() => {
    history.push('/dashboard');
  }, 500),
  { error: ERROR, loading: LOADING, responder: SIGNIN }
);

export const signup = (email, username, password, history) => Helpers.api(
  'signup',
  'POST',
  { email, password, username },
  () => setTimeout(() => {
    history.push('/signin');
  }, 500),
  { error: ERROR, loading: LOADING, responder: SIGNUP }
);

export const logout = history => dispatch => {
  dispatch({
    payload: null,
    type: LOGOUT,
  });
  history.push('/signin');
};

export const load = () => Helpers.api(
  'user',
  'GET',
  null,
  null,
  { error: ERROR, loading: LOADING, responder: LOAD }
);

export const getBalance = () => Helpers.api(
  'balance',
  'GET',
  null,
  null,
  { error: ERROR, loading: LOADING, responder: BALANCE }
);

export const setBalance = amount => Helpers.api(
  'balance',
  'PUT',
  { amount },
  null,
  { error: ERROR, loading: LOADING, responder: BALANCE }
);
